module.exports = __webpack_public_path__ + "img/组 190.6ec81fa5.png";